<template>
  <div>
    <v-list-item
      :disabled="!cuentaSelected || cuenta.cierre != null"
      @click="onSubmit"
      v-if="$can('cuentas.recalcular')"
    >
      <v-list-item-icon>
        <v-icon>mdi-keyboard-f6</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Recalcular saldo</v-list-item-title>
      <v-list-item-icon>
        <v-icon>mdi-cash-sync</v-icon>
      </v-list-item-icon>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: 'RecalcularComponent',
  data () {
    return {
      isFnPressed: false,
    }
  },
  beforeMount () {
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  computed: {
    cuenta () {
      return this.$store.getters['Cuentas/selected']
    },
    cuentaSelected () {
      return this.cuenta && this.cuenta.id > 0;
    },
  },
  methods: {
    handleKeyboard(event) {
      if (event.key === 'F6' && !event.ctrlKey) {
        if (!this.isFnPressed) {
          this.isFnPressed = true;
          
          if (this.cuentaSelected) {
            this.onSubmit(event)
          } else {
            event.preventDefault();
            alert('Primero debe seleccionar una cuenta y un periodo!');
            this.isFnPressed = false;
          }
        }
      }
    },
    async onSubmit(event) {
      event.preventDefault()
      if (!this.$can('cuentas.recalcular')) return
      const confirmacion = confirm('Vamos a recalcular los saldos de esta cuenta. ¿Deseas continuar?');
      let msg = ''
      if (confirmacion) {
        await this.$store.dispatch('RecalcularSaldo/onSave', this.cuenta.id);
        await this.$store.dispatch('Cuentas/onRefresh');
        await this.$store.dispatch('Transacciones/onFetch');
        this.isFnPressed = await false;
      }
      else alert('El proceso ha sido cancelado');
    },
  },

}
</script>
